import gsap from "gsap";
import React, { useEffect } from "react";
import { ScrollScene } from "scrollscene";
import { ICouponDisplayStrings } from "../../../components/presentational/views/Promo/LandingCouponPage/types/landingCouponPageTypes";
import { useMediaQueries } from "../../../hooks/useMediaQueries";
import "../styles/FourthSectionPromo.scss";

export const FourthSectionPromo = ({
  couponDetails,
  onSignUp,
}: {
  couponDetails: ICouponDisplayStrings;
  onSignUp: (buttonClassName: string) => void;
}): React.ReactElement => {
  const { mobile } = useMediaQueries();

  // INTENDED as useRef needs null
  // eslint-disable-next-line no-null/no-null
  const containerRef = React.useRef(null);
  useEffect(() => {
    const { current: containerElement } = containerRef;

    if (!containerElement) {
      return undefined;
    }

    const timeline = gsap.timeline({ paused: true });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: FIX
    const scrollScene = new ScrollScene({
      gsap: { timeline },
      toggle: { className: "in-view", element: containerElement },
      triggerElement: containerElement,
      triggerHook: 0.8,
    });

    return () => {
      scrollScene.destroy();
    };
  });

  return (
    <div className="fourth-section" ref={containerRef}>
      <svg
        className="wave-container"
        preserveAspectRatio="none"
        viewBox="0 0 100 100"
      >
        <path
          className="wave"
          d="M 0,100  L 0,0 C 40,0 60,100 100,100 C 140,100 160,0 200,0 C 240,0 260,100 300,100"
        />
      </svg>
      {!mobile && (
        <span className="title">
          Learn grammar intuitively in the context of sentences{" "}
          <span className="highlight">you</span> care about.
        </span>
      )}
      <div className="button-container">
        <div
          className="button fourth-section-button"
          onClick={() => onSignUp("fourth-section-button")}
        >
          {`Redeem your ${couponDetails.detailText} now!`}
        </div>
        <div className="subtitle">
          <p>{`${couponDetails.footerPricing}`}</p>
          <p>No commitment. Cancel anytime.</p>
        </div>
      </div>
    </div>
  );
};
